// /src/store/modules/taxies.js
// import { apiGet, futureDate } from '@/services/API'
// import { tStore } from '@/services/Storage'
import _filter from 'lodash/filter'
import CommonGetters from '@/store/common/getters'

export const namespaced = true

// let taxPolling = null
// console.log(authors)
// authors.forEach(a => {
//   if (a.id == 288) {
//     console.log(a)
//   }
// })

// console.log(authors);

// console.log(services);
// console.log(Object.keys(services))

// const geographies = Object.keys(geographies).map(geo => {
//   return geo
// })

// console.log(geographies);

export const state = {
  nextAPIRun: 0,
  authors: {
    data: authors,
  },
  // vendors: {
  //   data: vendors,
  // },
  categories: {
    data: [],
  },
  'deal_types': {
    data: dealTypes,
  },
  'deal-phases': {
    data: dealPhases,
  },
  origin: {
    data: origin,
  },
  tags: {
    data: tags,
  },
  // tools: {
  //   data: tools,
  // },
  verticals: {
    data: verticals,
  },
  industries: {
    data: industries,
  },
  services: {
    data: services,
  },
  geographies: {
    data: geographies,
  },
  rel_managers: {
    data: rel_managers,
  },
  bibleTopics: {
    data: bibleTopics,
  },
  subtitle_groups: {
    data: subtitleGroups,
  },
  // 'content_types': {
  //   data: contentTypes,
  // },
  scriptureReferences: {
    data: scriptureReferences,
  },
  user_groups: {
    data: [],
  },
}

export const mutations = {
  SET_USER_GROUPS(state, groups) {
    state.user_groups = groups
  },
//   SET_API_NEXT_RUN(state, date) {
//     state.nextAPIRun = date
//   },
//   SET_AUTHORS(state, authors) {
//     state.authors = authors
//   },
//   SET_CATEGORIES(state, categories) {
//     state.categories = categories
//   },
//   SET_DEAL_PHASES(state, dealPhases) {
//     state['deal-phases'] = dealPhases
//   },
//   SET_ORIGINS(state, origins) {
//     state.origins = origins
//   },
//   SET_TAGS(state, tags) {
//     state.tags = tags
//   },
//   SET_TOOL_TAX(state, tools) {
//     state.tools = tools
//   },
//   SET_VERTICALS(state, verticals) {
//     state.verticals = verticals
//   },
}

export const actions = {
  compileUserGroups({rootState, commit}) {
    const userGroups = rootState.user.groups
    const availableGroups = systemUserGroups
    commit('SET_USER_GROUPS', {
      data: userGroups.length > 0 ? _filter(availableGroups, group => userGroups ? userGroups.includes(group.term_id) : false ) : [],
      title: 'User Group',
      titlePlural: 'User Groups',
    })
  },
//   getAll({ commit, state, dispatch }) {
//     try {
//       const currentDateTime = new Date().getTime()
//       if (state.nextAPIRun < currentDateTime) {
//         dispatch('requestTaxies')
//       }
//       dispatch('polling', true)
//     } catch (err) {
//       // console.log(err)
//       dispatch(
//         'notification/add',
//         {
//           type: 'error',
//           msg: 'There was a problem fetching all taxonomies: ' + err,
//           closable: true,
//           autoClose: false,
//         },
//         { root: true },
//       )
//     }
//   },
//   async requestTaxies({ commit, state, dispatch }) {
//     const apiRequests = tStore.apiRequests
//     try {
//       await Promise.all(
//         Object.keys(apiRequests).map(async key => {
//           try {
//             const config = apiRequests[key]
//             const { data } = await apiGet(config.apiPath)
//             if (data) {
//               const storeTaxItem = {
//                 title: config.title,
//                 routePath: config.routePath,
//                 titlePlural: config.titlePlural,
//                 data,
//               }
//               commit(config.stateCommit, storeTaxItem)
//               if (Array.isArray(data) && data.length > 0)
//                 dispatch('updateAPIRunTimes')
//             }
//           } catch (err) {
//             dispatch('polling', false)
//             // console.log(err)
//             dispatch(
//               'notification/add',
//               {
//                 type: 'error',
//                 msg: 'Request Taxonomies Failed: ' + err.data.message,
//                 closable: true,
//                 autoClose: false,
//               },
//               { root: true },
//             )
//             throw err
//           }
//         }),
//       )
//     } catch (err) {
//       dispatch('polling', false)
//       dispatch(
//         'notification/add',
//         {
//           type: 'error',
//           msg: 'Request Taxonomies Failed: ' + err.data.message,
//           closable: true,
//           autoClose: false,
//         },
//         { root: true },
//       )
//     }
//   },
//   polling({ commit, dispatch }, bool = true) {
//     if (!bool) {
//       clearInterval(taxPolling)
//       taxPolling = null
//       return
//     }
//     if (taxPolling === null) {
//       taxPolling = setInterval(function() {
//         dispatch('getAll')
//       }, 600000)
//     }
//   },
//   updateAPIRunTimes({ commit }) {
//     commit('SET_API_NEXT_RUN', futureDate(new Date().getTime())) // default date time set by API
//   },
}

export const getters = {
  ...CommonGetters,
}
